/* eslint-disable */
import {
  ControlledMultiSelect,
  CustomButton,
  FormInput,
  Modal,
  PaginatedControlledDropDown,
  SvgCross,
  SvgDocuSign,
  SvgEdit,
  SvgSetting,
  SvgSettingEnabled,
  Tooltip,
  SvgWarningNew,
  SvgDownloadGrey,
  PdfViewer,
  getFileIcon,
  isWordOrExcelOrCsvDocument,
  ControlledDropDown,
  GenericRenderPreview,
  PhoneInput,
  MultiLineInput,
  HTML_TYPE,
  formatPhoneNumber,
  FORMAT_PATTERN,
} from '@ui-kit'
import { useEffect, useRef, useState } from 'react'
import {
  API_END_POINT,
  Attachment,
  axiosInstance,
  DataType,
  manualCommunicationDataTypeAgent,
  previewTemplatePayloadType,
  resetSelectedManualCommunicationState,
  sendTemplatePreviewPayload,
  fetchAllAttachmentsForATemplateById,
  hideLoader,
  addToaster,
  showLoader,
  sendCommunicationTemplateToRecipientApi,
  sendCommunicationTemplateToRecipientViaDocuSignApi,
  sendTemplatePayloadDocuSignType,
  ENCRYPTDATA_TYPE,
  sendTemplatePayloadEnhancementType,
  ErrorResponse,
  getPreviewTemplateByCaseidAndTemplateId,
  fetchFaxIdCorrespondingData,
  selectedManualCommunication,
  getSearchedTemplatesinManualCommunicationApi,
  getEmailTemplateByIdApi,
  SEND_MANUAL_COMMUNICATION_CONSTANT,
  DropdownType,
  AttachmentFaxOutboundType,
  WORKFLOW_UI_IDENTIFIER,
  getGenericEntityListingAPI,
  GetGenericEntityListingApiType,
  getInsuranceOptions,
  getAppealInsuranceOptions,
  saveTaskDataApi,
  resendCorrespondenceLogsApi,
} from '@app-store'
import { FieldValues, useForm } from 'react-hook-form'
import {
  BUTTONS,
  COMM_TEMPLATE,
  EXTRACT_EMAIL_FROM_VIEW_OBJECT_REGEX,
  FIELD_VALUE_CONSTANTS,
  MODAL_TYPES,
  NAMESPACES_MANUAL_COMMUNICATION,
  REDIRECTING_TO_DOCUSIGN,
  NUMBER_REGEX_WHILE_SENDING,
  ENTITY_ID,
  PHONE_TYPE_CATEGORY_VALUES,
  WORKFLOW_STATUS,
} from '../../utils/constants'
import { isEmpty } from 'lodash'
import {
  extractTextFromHTML,
  fetchDocumentPdfByTemplateIdCaseId,
  formatHtmlBeforePreview,
  formatInsurancePhones,
  formattedViewObject,
  formattedViewObjectForLetter,
  formatUSPhoneNumber,
  getDownloadURL,
  getTooltipArray,
  loadCSSAndBuildHTMLForSendingCommunication,
  makeEditableWithRedBackground,
  permissionObject,
  removeEditableAndRedBackground,
  toTitleCase,
} from '../../utils/helperFunctions'
import { v4 as uuid } from 'uuid'
import CryptoJS from 'crypto-js'
import './SendManualCommunication.css'
import { AxiosError } from 'axios'
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from '../../utils/agent.store'
import DraggableAttachableList from './DraggableAttachableList'
import { SendManualCommunicationProps } from './SendManualCommunication.type'
import { ViewObjectEntry } from '../../types/types'
import MiscUploadButton from './MiscUploadButtonAgent'
import { isReadOnlyUser } from '../../utils/permission'
import { fetchFilePreviewUrlUsingFileName } from '../../apis/exportFile.api'
import DocumentPopout from './DocumentPopout'
import { NAMESPACES } from '../../utils/constants'
import { CORRESPONDENCE_LOGS_STRINGS } from '../../utils/strings'

const SendManualCommunication: React.FC<SendManualCommunicationProps> = (
  props: SendManualCommunicationProps
) => {
  const manualCommunicationData: manualCommunicationDataTypeAgent = {
    case_id: props.caseId,
    template_name: (props.preSelectedTemplateId as unknown as string) ?? '',
    mode_of_communication: '',
    program: props.programId,
    service: props.serviceId,
    recipient_phone_number: '',
    text_message: '',
    insurance_type: '',
  }
  const previewAttachmentPath = useRef('')
  const hasTaskUpdated = useRef(false)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const dispatch = useAppDispatch()
  const selectedTenantId = useAppSelector(
    (state: RootState) => state.authUser.selectedClientTenant?.id
  )

  const [previewTemplateData, setPreviewTemplateData] =
    useState<selectedManualCommunication | null>(null)
  const caseKey = useAppSelector(
    (state: RootState) => state?.workflowData?.caseDetails?.caseId
  )
  const programPermissions = useAppSelector(
    (state: RootState) => state.clientPermissions?.programPermissions
  )
  const caseData = useAppSelector(
    (state: RootState) => state.workflowData?.caseData
  )
  const organizationEntityId = useAppSelector(
    (state: RootState) =>
      state?.workflowData?.workflowDefinition?.global_variables?.entities
        ?.organization?.entity_id
  )
  const userId = useAppSelector((state: RootState) => state?.authUser?.user?.id)
  const isPapFax =
    props?.task?.identifier?.sub_ui_identifier ===
    WORKFLOW_UI_IDENTIFIER.PAP_SEND_COMMUNICATION_FAX
  const [currentPageTemplateName, setCurrentPageTemplateName] =
    useState<number>(0)
  const [sizeTemplateName, setSizeTemplateName] = useState<number>(20)
  const [previewDataWithLink, setPreviewDataWithLink] = useState<string | null>(
    null
  )
  const editableRef = useRef<HTMLDivElement>(null)
  const editableAttachmentRef = useRef<HTMLDivElement>(null)
  const [previewUrl, setPreviewUrl] = useState<string>('')
  const downloadUrl = useRef<string>('')
  const [documentType, setDocumentType] = useState<string>()

  const [isOpenModal, setIsOpenModal] = useState<boolean>(false)
  const [attachmentBody, setAttachmentBody] = useState<Attachment | null>()
  // const [programs, setPrograms] = useState<DropdownType<string>[]>([])
  // const [allServices, setAllServices] = useState<DropdownType<string>[]>([])
  const [allTemplates, setAllTemplates] = useState<DropdownType<string>[]>([])
  const [virtualScrollForTemplate, setVirtualScrollForTemplate] =
    useState<boolean>(true)
  const [editState, setEditState] = useState<boolean>(false)
  const [enableBtn, setEnableBtn] = useState<boolean>(false)
  // const [caseIds, setCaseIds] = useState<DropdownType<number>[]>()
  const [attachments, setAttachments] = useState<Attachment[]>([])
  const [attachmentData, setAttachmentData] = useState<string>('')
  const [modal, setModal] = useState<{ type: string; state: boolean }>({
    type: '',
    state: false,
  })
  // const [programServices, setProgramServices] = useState<ProgramService[]>([])
  const [previewData, setPreviewData] = useState<string>('')
  const [updatedData, setUpdatedData] = useState<string | null>(null)
  const [previewMap, setPreviewMap] = useState<{ [key: string]: string }>({})
  const [attachmentMap, setAttachmentMap] = useState<{
    [key: number]: { [key: string]: string }
  }>({})
  const [fetchAttachments, setFetchAttachments] = useState<Attachment[]>()
  const [fetchedAttachment, setFetchedAttachment] = useState<number>()
  const [attachmentsKey, setAttachmentsKey] = useState<Attachment[]>()
  const [hasSendManualPermission, setHasSendManualPermission] =
    useState<boolean>(false)
  const [staticFileName, setStaticFileName] = useState<string>('')
  const [envelopeId, setEnvelopeId] = useState<string>('')
  const [letterCount, setLetterCount] = useState<number>(0)
  const [viewObjects, setViewObjects] = useState<ViewObjectEntry[]>([])
  const [tooltipArray, setTooltipArray] = useState<{
    to: string[]
    cc: string[]
    bcc: string[]
  }>({
    to: [],
    cc: [],
    bcc: [],
  })
  const [allToEmails, setAllToEmails] = useState<DropdownType<string>[]>([])
  const [allBccEmails, setAllBccEmails] = useState<DropdownType<string>[]>([])
  const [allCcEmails, setAllCcEmails] = useState<DropdownType<string>[]>([])
  const [toLetterAddress, setToLetterAddress] = useState<
    DropdownType<string>[]
  >([])
  const [toSmsFax, setToSmsFax] = useState<DropdownType<string>[]>([])

  const [queuedFax, setQueuedFax] = useState<{
    id: string
    status: string
  } | null>(null)
  const [selectedRecipientLabel, setSelectedRecipientLabel] =
    useState<string>('')

  const {
    handleSubmit,
    register,
    formState: { errors },
    control,
    setValue,
    watch,
    reset,
    trigger,
  } = useForm({
    defaultValues: manualCommunicationData,
  })

  const [templateName, setTemplateName] = useState('')
  const [insuranceOptions, setInsuranceOptions] = useState([])
  const fetchAllTemplates = async (
    page: number,
    limit: number,
    value?: string,
    operator?: string
  ) => {
    try {
      dispatch(showLoader())
      const response = await getSearchedTemplatesinManualCommunicationApi(
        page,
        limit,
        [
          {
            search_key: SEND_MANUAL_COMMUNICATION_CONSTANT.PRODUCT_ID,
            operator: SEND_MANUAL_COMMUNICATION_CONSTANT.EQUALS,
            search_value: [parseInt(props?.productId)],
          },
          {
            search_key: SEND_MANUAL_COMMUNICATION_CONSTANT.PROGRAM_ID,
            operator: SEND_MANUAL_COMMUNICATION_CONSTANT.EQUALS,
            search_value: [parseInt(props?.programId)],
          },
          {
            search_key: SEND_MANUAL_COMMUNICATION_CONSTANT.SERVICE_ID,
            operator: SEND_MANUAL_COMMUNICATION_CONSTANT.EQUALS,
            search_value: [parseInt(props?.serviceId)],
          },

          {
            search_key: SEND_MANUAL_COMMUNICATION_CONSTANT.IS_ACTIVE,
            operator: SEND_MANUAL_COMMUNICATION_CONSTANT.EQUALS,
            search_value: [SEND_MANUAL_COMMUNICATION_CONSTANT.TRUE],
          },
          {
            search_key: SEND_MANUAL_COMMUNICATION_CONSTANT.TEMPLATE_NAME,
            operator: operator ?? SEND_MANUAL_COMMUNICATION_CONSTANT.CONTAINS,
            search_value: [value ?? ''],
          },
        ]
      )
      const dataResponse = response.data.content
      if (!isEmpty(dataResponse)) {
        setVirtualScrollForTemplate(true)
        const array = dataResponse
          // TODO: condition was added to filtered out only faxes from the communicaitons
          // ?.filter((item: DataType) => item.is_active && item?.correspondence_type === emailTemplate?.FAX)
          .map((item: DataType) => ({
            value: item?.id,
            label: item?.template_name,
            mode_of_communication: item?.correspondence_type,
            include_editable_text: item?.include_editable_text,
            program_services: item?.program_services,
          }))
        setAllTemplates((prevOptions) => {
          return [...(page === 0 ? [] : prevOptions ?? []), ...array]
        })
        setCurrentPageTemplateName(page)
        setSizeTemplateName(limit)
        return dataResponse
      } else {
        setVirtualScrollForTemplate(false)
      }
    } catch (error) {
      setVirtualScrollForTemplate(false)
      console.error(error)
    } finally {
      dispatch(hideLoader())
    }
  }

  const handleTemplateOptionChange = (e: DropdownType<string>) => {
    const templateId = e?.value
    // reset({ program: '', service: '', case_id: watch('case_id') })
    if (!previewTemplateData) {
      reset()
    }
    if (previewDataWithLink) {
      setPreviewDataWithLink(null)
    }
    setValue('template_name', templateId)

    getAndSetModeOfCommunication(e?.mode_of_communication?.toString())
    // setProgramServices(e?.program_services as unknown as ProgramService[])
    // const uniquePrograms = Array.from(
    //   new Map(
    //     programServices.map((item) => [
    //       item?.program?.id,
    //       {
    //         value: item?.program?.id.toString() ?? '',
    //         label: item?.program?.operationalProgramName ?? '',
    //       },
    //     ])
    //   ).values()
    // )
    // setPrograms(uniquePrograms)
    if (previewTemplateData) {
      dispatch(resetSelectedManualCommunicationState())
      setPreviewTemplateData(null)
      setValue('to', [])
      setValue('bcc', [])
      setValue('cc', [])
      setValue('letter_address', '')
    }
  }

  // const handleProgramOptionChange = (e: DropdownType<string>) => {
  //   setValue('program', e?.value)
  //   if (previewTemplateData) dispatch(resetSelectedManualCommunicationState())
  //   const programId = e?.value

  //   const serviceOptions = programServices
  //     .filter((item) => item?.program?.id === parseInt(programId))
  //     .map((item) => ({
  //       value: item.id.toString(),
  //       label: `${item?.program?.operationalProgramName}.${item?.service?.serviceName}`,
  //     }))
  //   setAllServices(serviceOptions)
  // }

  const fetchAllCases = async () => {
    try {
      dispatch(showLoader())
      // const response = await getAllCases({ case: 'case' })
      // const caseData = await getAllCasesData({ caseId: response?.data?.id })
      // const updatedData = caseData.data.map(
      //   (item: { id: number; name: string }) => {
      //     return {
      //       value: item?.id.toString(),
      //       label: item?.id.toString(),
      //     }
      //   }
      // )
      // setCaseIds(updatedData)
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const getAndSetModeOfCommunication = (value: string | undefined) => {
    if (!value) return
    switch (value) {
      case COMM_TEMPLATE.EMAIL_UPPERCASE:
        setValue('mode_of_communication', COMM_TEMPLATE.EMAIL)
        break
      case COMM_TEMPLATE.SMS_UPPERCASE:
        setValue('mode_of_communication', COMM_TEMPLATE.SMS)
        break
      case COMM_TEMPLATE.LETTER_UPPERCASE:
        setValue('mode_of_communication', COMM_TEMPLATE.LETTER)
        break
      case COMM_TEMPLATE.FAX_UPPERCASE:
        setValue('mode_of_communication', COMM_TEMPLATE.FAX)
        break
    }
  }

  const handleAttachmentEditClick = async (item: Attachment, type: string) => {
    setDocumentType(item?.attachment_document_type)
    if (
      item?.attachment_document_type === COMM_TEMPLATE.STATIC_DOCUMENT_UPPERCASE
    ) {
      if (isWordOrExcelOrCsvDocument(item?.attachment_name)) {
        await fetchFilePreviewUrl(item?.path ?? '')
        getDownloadURL(
          dispatch,
          watch('case_id'),
          downloadUrl.current,
          item?.attachment_name,
          item?.attachment_document_type
        )
      } else {
        handleViewClick(item?.attachment_name, item?.path?.toString() ?? '')
      }
      setFetchedAttachment(parseInt(item?.id ?? ''))
    } else {
      const attachmentInfo = fetchAttachments?.find(
        (value) => value.id === item?.id
      )
      try {
        dispatch(showLoader())
        const pdfData = await fetchDocumentPdfByTemplateIdCaseId(
          parseInt(props?.caseId) ?? 0,
          item.attachment_document_id ?? 0
        )
        if (pdfData?.documentType === COMM_TEMPLATE.DOCX_UPPERCASE) {
          handleViewClick(item?.attachment_name, pdfData?.pdfData)
          return
        }
        setTimeout(() => {
          setAttachmentData(pdfData?.pdfData)
        }, 0)
      } catch (error) {
        console.error('Error fetching PDF data:', error)
        setAttachmentData('')
      } finally {
        dispatch(hideLoader())
      }
      if (isWordOrExcelOrCsvDocument(item?.attachment_name)) {
        getDownloadURL(
          dispatch,
          caseKey ?? watch('case_id'),
          attachmentInfo?.attachment_data,
          attachmentInfo?.attachment_name,
          documentType
        )
      } else if (attachmentInfo || attachmentData) {
        // setAttachmentBody(null)
        setModal({
          type: type === MODAL_TYPES.LINK ? MODAL_TYPES.VIEW : MODAL_TYPES.EDIT,
          state: true,
        })
        setTimeout(() => {
          setAttachmentBody(attachmentInfo)
        }, 0)
      }
    }
  }

  const handleAttachmentDeleteClick = (itemToDelete: Attachment) => {
    const updatedAttachments = attachments.filter((item) => {
      if (itemToDelete.id !== undefined) {
        return item.id !== itemToDelete.id
      }
      return item.unique_attachment_name !== itemToDelete.unique_attachment_name
    })

    setAttachments(updatedAttachments)

    const updatedAttachmentsKey = updatedAttachments.map(
      (item: Attachment) => ({
        id: item?.id,
        unique_attachment_name: item?.unique_attachment_name,
        attachment_name: item?.attachment_name,
        attachment_document_type: item?.attachment_document_type,
        attachment_type: item?.attachment_type,
        attachment_document_id: item?.attachment_document_id,
        include_editable_text: item?.include_editable_text,
        contains_docusign: item?.contains_docusign,
        ...(item?.path ? { path: item.path } : {}),
      })
    )

    setAttachmentsKey(updatedAttachmentsKey)
  }

  const getEmailRecipient = (value: string | string[] | undefined): string => {
    if (!value) return ''
    return typeof value === 'string' ? value : value[0] ?? ''
  }

  // don't replace match with exec method here
  const extractRecipientsForPayload = (
    arr: (string | undefined)[],
    type: string
  ): string[] => {
    return arr
      .map((item) => {
        if (!item) return null
        const trimmedItem = item?.substring(2)

        let match: RegExpMatchArray | null = null
        if (type === COMM_TEMPLATE.EMAIL) {
          match = trimmedItem.match(EXTRACT_EMAIL_FROM_VIEW_OBJECT_REGEX)
        } else if (type === COMM_TEMPLATE.FAX) {
          match = trimmedItem.match(NUMBER_REGEX_WHILE_SENDING)
        }
        return match?.[match.length - 1] ?? null
      })
      .filter((val): val is string => val !== null)
  }

  const sendCommunicationTemplateFunction = async (
    payload: sendTemplatePayloadEnhancementType
  ) => {
    try {
      dispatch(showLoader())
      const response = await sendCommunicationTemplateToRecipientApi(
        {
          sendPayload: payload,
          envelopeId: envelopeId,
        },
        caseData?.programs?.id?.toString(),
        caseData?.services?.id?.toString()
      )
      if (response.data) {
        setQueuedFax({
          id: response?.data?.id,
          status: response?.data?.status,
        })

        await props?.updateTaskResource?.(props?.task, {
          resource_id: response?.data?.id,
          template_id: isPapFax
            ? watch('insurance_type')
            : watch('template_name'),
        })
        hasTaskUpdated.current = true
        dispatch(
          addToaster({
            message: `${payload?.correspondence_type}${COMM_TEMPLATE.SUCCESSFULLY_QUEUED}`,
            type: 'success',
            id: uuid(),
          })
        )
      }

      dispatch(resetSelectedManualCommunicationState())
      // reset()
      setEnvelopeId('')
      // setEnableBtn(false)
    } catch (err) {
      console.error(err)
      if (
        ((err as AxiosError)?.response?.data as ErrorResponse)?.message ===
        COMM_TEMPLATE?.CONFLICT_RECIPIENT_API_MESSAGE
      ) {
        dispatch(
          addToaster({
            message: COMM_TEMPLATE?.CONFLICT_RECIPIENT_TOASTER_MESSAGE,
            type: 'error',
            id: uuid(),
          })
        )
      } else {
        dispatch(
          addToaster({
            message: `Failed to queue ${payload?.correspondence_type}`,
            type: 'error',
            id: uuid(),
          })
        )
      }
    } finally {
      dispatch(hideLoader())
    }
  }

  const getRecipientToArray = (
    value: string | string[] | undefined
  ): string[] => {
    if (!value) return []
    return typeof value === 'string' ? [value] : value.filter(Boolean)
  }
  const sendCommunicationTemplateFunctionViaDocuSign = async (
    payload: sendTemplatePayloadDocuSignType
  ) => {
    try {
      dispatch(showLoader())
      const response = await sendCommunicationTemplateToRecipientViaDocuSignApi(
        payload
      )
      setEnvelopeId(response?.data?.envelopeId)
      const encryptData = (data: ENCRYPTDATA_TYPE, secretKey: string) => {
        const iv = CryptoJS.lib.WordArray.random(FIELD_VALUE_CONSTANTS.SIXTEEN)
        const encrypted = CryptoJS.AES.encrypt(
          JSON.stringify(data),
          secretKey,
          {
            iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
          }
        ).toString()

        return {
          encryptedData: encodeURIComponent(encrypted),
          iv: encodeURIComponent(iv.toString(CryptoJS.enc.Base64)),
        }
      }

      const { encryptedData, iv } = encryptData(
        response.data,
        REDIRECTING_TO_DOCUSIGN.SECRET_KEY
      )
      const parser = new DOMParser()
      const doc = parser.parseFromString(previewData, 'text/html')
      const newParagraph = document.createElement('p')

      const linkElement = document.createElement('a')
      linkElement.href = `${window.location.origin}/docuSign?data=${encryptedData}&iv=${iv}`
      const spanElement = document.createElement('span')
      spanElement.style.color = '#3396F3'
      spanElement.textContent = `${window.location.origin}/docuSign?data=${encryptedData}&iv=${iv}`
      linkElement.appendChild(spanElement)
      newParagraph.appendChild(linkElement)
      doc.body.appendChild(newParagraph)
      const serializer = new XMLSerializer()
      const modifiedHtml = serializer.serializeToString(doc)
      setPreviewData(modifiedHtml)
      setPreviewDataWithLink(modifiedHtml)
      dispatch(
        addToaster({
          message: REDIRECTING_TO_DOCUSIGN.REDIRECTING_LINK_ADDED_SUCCESSFULLY,
          type: 'success',
          id: uuid(),
        })
      )
      // TODO: required in future
      // dispatch(resetSelectedManualCommunicationState())
      // reset()
    } catch (err) {
      console.error(err)
      dispatch(
        addToaster({
          message: REDIRECTING_TO_DOCUSIGN.FAILED_TO_ADD_REDIRECTING_LINK,
          type: 'error',
          id: uuid(),
        })
      )
    } finally {
      dispatch(hideLoader())
    }
  }

  const sendCommunicationTemplate = async () => {
    const result = await trigger()
    if (!result) return
    const sendEdit: sendTemplatePreviewPayload = {
      type: 0,
      editableValues: previewMap,
    }
    const sendAttachment = Object.keys(attachmentMap).map((key) => ({
      type: 1,
      documentId: Number(key),
      editableValues: attachmentMap[Number(key)],
    }))
    const sendPayload = [sendEdit, ...sendAttachment]
    let additionalFields
    const finalAttachments = attachmentsKey?.map((item: Attachment) => ({
      id: item?.id,
      attachment_name: item?.attachment_name,
      attachment_document_type: item?.attachment_document_type,
      attachment_type: item?.attachment_type,
      attachment_document_id: item?.attachment_document_id,
      include_editable_text: item?.include_editable_text,
      contains_docusign: item?.contains_docusign,
      ...(item?.path ? { path: item.path } : {}),
    }))
    if (!finalAttachments?.length) {
      let errorMessage = COMM_TEMPLATE?.ATTACHMENT_VALIDATION_WHILE_SENDING_MSG
      if (watch('mode_of_communication') === COMM_TEMPLATE.EMAIL) {
        errorMessage =
          COMM_TEMPLATE?.ATTACHMENT_VALIDATION_WHILE_SENDING_MSG_EMAIL
      } else if (watch('mode_of_communication') === COMM_TEMPLATE.LETTER) {
        errorMessage =
          COMM_TEMPLATE?.ATTACHMENT_VALIDATION_WHILE_SENDING_MSG_LETTER
      }
      dispatch(
        addToaster({
          message: errorMessage,
          type: 'error',
          id: uuid(),
        })
      )
      return
    }

    if (watch('mode_of_communication') === COMM_TEMPLATE.EMAIL) {
      const initialMails = getRecipientToArray(watch('to'))
      const allEmails = extractRecipientsForPayload(
        initialMails,
        COMM_TEMPLATE.EMAIL
      )
      additionalFields = {
        recipient_to: allEmails,
        recipient_bcc: extractRecipientsForPayload(
          watch('bcc') ?? [],
          COMM_TEMPLATE.EMAIL
        ),
        recipient_cc: extractRecipientsForPayload(
          watch('cc') ?? [],
          COMM_TEMPLATE.EMAIL
        ),
        subject: watch('subject'),
        correspondence_type: 'EMAIL',
        attachment: finalAttachments,
      }
    } else if (watch('mode_of_communication') === COMM_TEMPLATE.SMS) {
      additionalFields = {
        recipient_to: extractRecipientsForPayload(
          (watch('to') as string[]) ?? [],
          COMM_TEMPLATE.FAX
        ),
        correspondence_type: 'SMS',
        recipient_cc: [],
        recipient_bcc: [],
      }
    } else if (watch('mode_of_communication') === COMM_TEMPLATE.FAX) {
      additionalFields = {
        recipient_to: extractRecipientsForPayload(
          [watch('to') as string],
          COMM_TEMPLATE.FAX
        ),
        correspondence_type: COMM_TEMPLATE.FAX_UPPERCASE,
        attachment: finalAttachments,
        recipient_cc: [],
        recipient_bcc: [],
      }
    } else if (watch('mode_of_communication') === COMM_TEMPLATE.LETTER) {
      additionalFields = {
        recipient_to:
          [watch('letter_address')]?.map((str) => str?.slice(2)) ?? [],
        recipient_cc: [],
        recipient_bcc: [],
        correspondence_type: 'LETTER',
        attachment: finalAttachments,
      }
    }
    const payload: sendTemplatePayloadEnhancementType = {
      case_id: parseInt(watch('case_id')),
      template_id: parseInt(watch('template_name')),
      service_id: props?.sendServiceId
        ? parseInt(props?.sendServiceId ?? '')
        : parseInt(watch('service')),
      body:
        loadCSSAndBuildHTMLForSendingCommunication(
          previewTemplateData?.body_type === HTML_TYPE.DOCX_UPPPERCASE
            ? previewTemplateData?.body ?? ''
            : previewData,
          previewTemplateData?.body_type
        ) ?? '',
      editable_fields: sendPayload,
      view_object: viewObjects,
      ...additionalFields,
    }
    if (payload?.recipient_to?.length)
      sendCommunicationTemplateFunction(payload)
    else {
      dispatch(
        addToaster({
          message: COMM_TEMPLATE?.PLEASE_ENTER_A_VALID_RECIPIENT,
          type: 'error',
          id: uuid(),
        })
      )
    }
  }

  const sendCommunicationTemplateViaDocuSign = async () => {
    const result = await trigger()
    if (!result) return
    const sendEdit: sendTemplatePreviewPayload = {
      type: FIELD_VALUE_CONSTANTS.ZERO,
      editableValues: previewMap,
    }
    const sendAttachment = Object.keys(attachmentMap).map((key) => ({
      type: FIELD_VALUE_CONSTANTS.ONE,
      documentId: Number(key),
      editableValues: attachmentMap[Number(key)],
    }))
    const sendPayload = [sendEdit, ...sendAttachment]
    const intialMails = getEmailRecipient(watch('to'))
    const allEmails = extractRecipientsForPayload(
      [intialMails],
      COMM_TEMPLATE.EMAIL
    )
    const payload = {
      caseId: parseInt(watch('case_id')),
      templateId: parseInt(watch('template_name')),
      email: allEmails?.[0],
      modeOfCommunication: watch('mode_of_communication'),
      sendPayload: sendPayload,
    }
    sendCommunicationTemplateFunctionViaDocuSign(payload)
  }

  // const resendCorresponsence = async () => {
  //   const response = await resendCorrespondenceLogsApi(
  //     props?.task?.resource_id ?? ''
  //   )
  //   if (response?.data?.id) {
  //     await props?.createTask?.({
  //       taskName: NAMESPACES.RELAY_RESULTS,
  //       taskSummary: '',
  //       dueDate: props?.task?.due_date,
  //       startDate: props?.task?.start_date,
  //       status: WORKFLOW_STATUS.COMPLETED,
  //       assignee: {
  //         id: props?.task?.assignee?.id,
  //       },
  //       task_template: {
  //         id: props?.task?.task_template?.id,
  //         name: props?.task?.task_template?.name,
  //       },
  //       entityType: '',
  //       entityName: '',
  //       blockPopup: true,
  //     })
  //     props?.refetch?.()
  //   }
  // }
  const onSubmit = async () => {
    const data = watch()
    try {
      dispatch(showLoader())
      const payload: previewTemplatePayloadType = {
        caseId: parseInt(data?.case_id),
        templateId: parseInt(data?.template_name),
        isEditable: true,
        programId: parseInt(data?.program),
      }
      const response = await getPreviewTemplateByCaseidAndTemplateId(
        payload,
        caseData?.programs?.id?.toString(),
        caseData?.services?.id?.toString()
      )
      if (props.task.identifier?.use_dynamic_receiver) {
        const orgName = props.task.identifier.template?.dynamic_fax_name ?? ''
        const orgNumber = formatUSPhoneNumber(
          props.task.identifier.template?.dynamic_fax_number ?? ''
        )
        const modified = [...response.data.view_object]
        modified[0] = {
          ...modified[0],
          name: [
            {
              key: 'receiver_name',
              value: orgName,
            },
          ],
          recipient: orgNumber,
          recipient_label: 'receiver_fax',
          record_ids: [props?.task?.organization_view?.record_id],
          entity_name: 'organizations',
          record_keys: [props?.task?.organization_view?.record_key],
          entity: 'organizations',
          entity_id: organizationEntityId,
          type: 'to',
        }
        response.data.view_object = modified
      }

      if (response.data.body_type === HTML_TYPE.DOCX_UPPPERCASE) {
        setPreviewData(response.data.body ?? '')
      }

      setPreviewTemplateData(response.data)
      if (watch('mode_of_communication') !== COMM_TEMPLATE?.SMS) {
        // fetchAllAttachmentsForATemplate()
      }
      setUpdatedData(null)
      setEditState(false)
    } catch (error) {
      console.error(error)
    } finally {
      dispatch(hideLoader())
    }
  }

  const handleSave = () => {
    if (!isEmpty(editableRef.current)) {
      const updatedHtml = editableRef?.current?.innerHTML

      const parser = new DOMParser()
      const doc = parser.parseFromString(updatedHtml, 'text/html')
      const editableDivs = doc.querySelectorAll('div')

      const initialPreviewMap: { [key: string]: string } = {}

      editableDivs.forEach((div) => {
        if (div.className.startsWith('editable')) {
          const innerText = div.innerText

          div.innerHTML = `<span style="background-color: inherit" contenteditable="false">${innerText}</span>`

          const className = div.getAttribute('class')?.toString()
          if (className) {
            initialPreviewMap[className] = innerText
          }
        }
      })
      setPreviewMap((prevMap) => ({ ...prevMap, ...initialPreviewMap }))
      const updatedHtmlWithChanges = doc.documentElement.innerHTML
      setUpdatedData(updatedHtmlWithChanges)
    }
    setEditState(false)
  }
  const handleSaveAttachments = () => {
    if (!isEmpty(editableAttachmentRef.current)) {
      const updatedHtml = editableAttachmentRef?.current?.innerHTML
      const parser = new DOMParser()
      const doc = parser.parseFromString(updatedHtml, 'text/html')
      const editableDivs = doc.querySelectorAll('div')

      const initialEditMap: { [key: string]: string } = {}

      editableDivs.forEach((div) => {
        if (div.className.startsWith('editable')) {
          const innerText = div.innerText

          div.innerHTML = `<span style="background-color: inherit" contenteditable="false">${innerText}</span>`

          const className = div.getAttribute('class')?.toString()
          if (className) {
            initialEditMap[className] = innerText
          }
        }
      })
      setAttachmentMap((prevMap) => {
        const updatedMap: { [key: number]: { [key: string]: string } } = {
          ...prevMap,
          [Number(fetchedAttachment)]: initialEditMap,
        }
        const numericKeyMap = Object.keys(updatedMap)
          .filter((key) => !isNaN(Number(key)))
          .reduce<{ [key: number]: { [key: string]: string } }>((obj, key) => {
            obj[Number(key)] = updatedMap[Number(key)]
            return obj
          }, {})

        return numericKeyMap
      })
      setFetchAttachments((prevAttachments) =>
        prevAttachments?.map((attachment: Attachment) =>
          attachment.id === fetchedAttachment
            ? { ...attachment, attachment_data: updatedHtml }
            : attachment
        )
      )
      setModal({ type: '', state: false })
    }
  }

  const fetchFilePreviewUrl = async (fileName: string) => {
    try {
      dispatch(showLoader())
      const response = await axiosInstance.get(
        `${API_END_POINT.CORE}v1/files/generate-download-url?fileName=${fileName}`,
        {
          headers: {
            'x-tenantid': selectedTenantId,
          },
        }
      )
      if (response.data) {
        setPreviewUrl(response.data?.url)
        downloadUrl.current = response.data?.url
        return response.data?.url
      }
    } catch (error) {
      console.error('Error in API request:', error)
      setPreviewUrl('')
    } finally {
      dispatch(hideLoader())
    }
  }

  const handleViewClick = async (filename: string, path?: string) => {
    previewAttachmentPath.current = path ?? ''
    await fetchFilePreviewUrl(path ?? '')
    setIsOpenModal(true)
    setStaticFileName(filename)
  }

  // const getFaxStatus = async () => {
  //   const res = await fetchFaxStatus()
  // }

  // const handleCaseIdChange = (e: DropdownType<number>) => {
  //   setValue('case_id', e?.value)
  //   if (previewTemplateData) dispatch(resetSelectedManualCommunicationState())
  // }

  // const handleServiceOptionChange = (e: DropdownType<string>) => {
  //   setValue('service', e?.value)
  //   if (previewTemplateData) dispatch(resetSelectedManualCommunicationState())
  // }
  // const handleDragEnd = (result: DropResult) => {
  //   {
  //     if (!result.destination) return
  //     const reorderedAttachments = Array.from(attachments)
  //     const [removed] = reorderedAttachments.splice(result.source.index, 1)
  //     reorderedAttachments.splice(result.destination.index, 0, removed)
  //     setAttachments(reorderedAttachments)
  //     const tempAttachmentKey = reorderedAttachments.map((item: Attachment) => {
  //       return {
  //         id: item?.id,
  //         attachment_name: item?.attachment_name,
  //         attachment_document_type: item?.attachment_document_type,
  //         attachment_type: item?.attachment_type,
  //         attachment_document_id: item?.attachment_document_id,
  //         include_editable_text: item?.include_editable_text,
  //         contains_docusign: item?.contains_docusign,
  //         path: item?.path,
  //       }
  //     })
  //     setAttachmentsKey(tempAttachmentKey)
  //   }
  // }

  const fetchTooltips = async (arr: ViewObjectEntry[], type = 'to') => {
    // dispatch(showLoader())
    const tooltipArr = await getTooltipArray(
      type,
      arr,
      watch('mode_of_communication')
    )
    setTooltipArray((prev) => ({
      ...prev,
      [type]: tooltipArr,
    }))
    if (arr.length > 0 && arr.length < 2) {
      setValue('to', formattedViewObject('to', arr ?? [])?.[0].value)
    }
    // dispatch(hideLoader())
  }

  const handleDisable = () => {
    if (watch('mode_of_communication') === COMM_TEMPLATE.SMS) {
      return (
        extractRecipientsForPayload(
          (watch('to') as string[]) ?? [],
          COMM_TEMPLATE.FAX
        ).length === 0
      )
    } else if (watch('mode_of_communication') === COMM_TEMPLATE.FAX) {
      return (
        extractRecipientsForPayload(
          [(watch('to') as string) ?? ''],
          COMM_TEMPLATE.FAX
        ).length === 0
      )
    } else if (watch('mode_of_communication') === COMM_TEMPLATE.EMAIL) {
      const initialMails = getRecipientToArray(watch('to'))
      const allEmails = extractRecipientsForPayload(
        initialMails,
        COMM_TEMPLATE.EMAIL
      )
      return allEmails?.length === 0
    } else if (watch('mode_of_communication') === COMM_TEMPLATE.LETTER) {
      return (watch('letter_address') ?? [])?.length === 0
    }
  }
  const getGenerateSendButtonClass = (enableBtn: boolean) =>
    enableBtn ? 'bg-primary-500' : 'bg-accent-100'

  const getGenerateSendButtonIcon = (enableBtn: boolean) =>
    !enableBtn ? <SvgSetting /> : <SvgSettingEnabled />

  const getGenerateTextClassName = (enableBtn: boolean) =>
    enableBtn ? 'text-accent-0' : 'text-accent-600'

  const checkIfEnabled = (previewDataWithLink: string | null) =>
    !!previewDataWithLink

  const getButtonText = () =>
    props?.task?.resource_id ? BUTTONS?.RESEND : BUTTONS.SEND

  const getClassOnEditState = (editState: boolean) =>
    editState ? 'bg-accent-0 with-shadow' : 'bg-accent-100'

  const getFormatedHtmlData = (editState: boolean, previewData: string) =>
    editState
      ? makeEditableWithRedBackground(previewData)
      : removeEditableAndRedBackground(previewData)

  const transformToAttachment = (
    data: AttachmentFaxOutboundType,
    attachmentsId: number
  ) => {
    const cleanedPath = data?.path?.replace(/\/+$/, '') ?? ''
    const fileName = data?.name ?? ''

    return {
      attachment_name: data.alias ?? data?.name ?? '',
      attachment_document_id: data?.exp ?? 0,
      attachment_type: data.extension ?? '',
      attachment_url: data.name ?? '',
      attachment_document_type: COMM_TEMPLATE.STATIC_DOCUMENT_UPPERCASE,
      awsFileName: data?.name ?? '',
      attachment_data: data.name ?? '',
      contains_docusign: data?.metaData?.isDocusign ?? false,
      id: `${attachmentsId}_${data?.name}`,
      path: cleanedPath.endsWith(fileName)
        ? cleanedPath
        : `${cleanedPath}/${fileName}`,
    }
  }

  const fetchStatus = async () => {
    try {
      if (isPapFax) {
        setValue('insurance_type', props?.task?.identifier?.template_id)
      }
      const responseStatus = await fetchFaxIdCorrespondingData(
        Number(props?.task?.resource_id)
      )
      if (responseStatus?.data) {
        setQueuedFax({
          id: responseStatus?.data?.id,
          status: responseStatus?.data?.category_status_id,
        })
        props?.isAutoTask &&
          getAndSetModeOfCommunication(
            responseStatus?.data?.category_communication_type_id
          )
        props?.isAutoTask &&
          setValue('template_name', responseStatus?.data?.template_id)

        props?.isAutoTask &&
          props.isDisabled &&
          setTemplateName(responseStatus?.data?.template_name)

        props?.isAutoTask &&
          props?.isAutoSms &&
          setValue(
            'recipient_phone_number',
            responseStatus?.data?.recipients_to?.[0].toString() ?? ''
          )
        props?.isAutoTask &&
          props?.isAutoSms &&
          setValue('text_message', responseStatus?.data?.body)

        // RETAIN VALUES
        setValue('template_name', responseStatus?.data?.template_id)
        setValue('to', responseStatus?.data?.view_object?.[0]?.recipient)
        setValue(
          'mode_of_communication',
          toTitleCase(responseStatus?.data?.discriminator)
        )
        const viewObjects = responseStatus?.data?.view_object ?? []

        if (responseStatus?.data?.discriminator?.toLowerCase() === 'letter') {
          const formattedLetterArray = formattedViewObjectForLetter(
            'to',
            viewObjects
          )
          const label = formattedLetterArray?.[0]?.label ?? ''
          setSelectedRecipientLabel(label)
        } else {
          const formattedToArray = formattedViewObject(
            'to',
            viewObjects,
            [''],
            watch('mode_of_communication')
          )
          const label = formattedToArray?.[0]?.label ?? ''
          setSelectedRecipientLabel(label)
        }

        const attachments = responseStatus?.data?.document_entities?.attachment
          ?.filter(
            (item: AttachmentFaxOutboundType) =>
              item?.description !== 'cover_sheet'
          )
          .map(transformToAttachment)

        setAttachments(attachments)
        setPreviewData(responseStatus?.data?.body)
        setPreviewTemplateData(responseStatus?.data)
      }
    } catch (err) {
      console.error(err)
    }
  }
  const getSelectedTemplate = async (id: number) => {
    const response = await getEmailTemplateByIdApi({ id })
    if (response?.data) {
      await fetchAllTemplates(
        currentPageTemplateName,
        sizeTemplateName,
        response.data.template_name,
        SEND_MANUAL_COMMUNICATION_CONSTANT.EQUALS
      )
    }
  }

  const fetchUrlWithLoader = async (fileName: string) => {
    try {
      dispatch(showLoader())
      const response = await fetchFilePreviewUrlUsingFileName(fileName)
      return response.data.url as string
    } catch (error) {
      console.error('Error in API request:', error)
    } finally {
      dispatch(hideLoader())
    }
  }

  const isCaseDetailsEditable = () => {
    return permissionObject.Manage_Workflow(
      programPermissions,
      caseData,
      props?.task,
      userId ?? ''
    )
  }

  const fetchInsuranceOptions = async () => {
    if (
      props?.task?.identifier?.sub_sub_ui_identifier ===
      WORKFLOW_UI_IDENTIFIER.APPEAL_SEND_COMMUNICATION_FAX
    ) {
      const response: FieldValues = await getAppealInsuranceOptions(
        parseInt(props?.caseId ?? '')
      )
      if (response) {
        const options = response?.data?.map((item: FieldValues) => {
          return {
            label: item?.type,
            value: item?.insuranceId,
            requestorId: item?.requestorId,
            phones: formatInsurancePhones(
              item as {
                insuranceId: number
                payerName: string
                phones: string
                recordKey: string
                type: string
              }
            ) as DropdownType<string>[],
          }
        })
        setInsuranceOptions(options)
      }
    } else {
      const response: FieldValues = await getInsuranceOptions(
        parseInt(props?.caseId ?? '')
      )
      if (response) {
        const options = response?.data?.map((item: FieldValues) => {
          return {
            label: item?.type,
            value: item?.insuranceId,
            requestorId: item?.requestorId,
            phones: formatInsurancePhones(
              item as {
                insuranceId: number
                payerName: string
                phones: string
                recordKey: string
                type: string
              }
            ) as DropdownType<string>[],
          }
        })
        setInsuranceOptions(options)
      }
    }
  }

  const handleInsuranceOptionChange = async (e: DropdownType<string>) => {
    setValue('insurance_type', e?.value)
    setToSmsFax(e?.phones as DropdownType<string>[])

    const payload = {
      id: Number(props?.task?.id),
      requestor_view: { id: null },
      organization_view: { id: e?.requestorId as number },
    }
    try {
      await saveTaskDataApi(
        props?.task?.id as string,
        payload,
        caseData?.programs?.id?.toString(),
        caseData?.services?.id?.toString()
      )
      props?.refetch?.()
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    if (allTemplates) {
      getAndSetModeOfCommunication(
        allTemplates
          ?.find((template) => template?.value === watch('template_name'))
          ?.mode_of_communication?.toString()
      )
    }
  }, [watch('template_name'), allTemplates])

  useEffect(() => {
    const caseId = watch('case_id')
    const template = watch('template_name')
    const program = watch('program')
    const service = watch('service')
    const insuranceType = watch('insurance_type')

    const allBaseFieldsPresent = caseId && template && program && service

    const canEnable =
      allBaseFieldsPresent && (!isPapFax || (isPapFax && insuranceType))

    setEnableBtn(!!canEnable)

    setEnvelopeId('')
  }, [
    watch('case_id'),
    watch('template_name'),
    watch('program'),
    watch('service'),
    watch('insurance_type'),
    isPapFax,
  ])

  useEffect(() => {
    if (!previewTemplateData) return
    const viewObjects = previewTemplateData?.view_object ?? []
    fetchTooltips(viewObjects, 'to')

    const isEmail =
      previewTemplateData?.correspondence_type ===
        COMM_TEMPLATE?.EMAIL_UPPERCASE ||
      previewTemplateData?.category_communication_type_id ===
        COMM_TEMPLATE?.EMAIL_UPPERCASE
    if (isEmail) {
      fetchTooltips(viewObjects, 'bcc')
      fetchTooltips(viewObjects, 'cc')
    }
  }, [previewTemplateData])

  useEffect(() => {
    if (previewTemplateData && tooltipArray) {
      const formattedToArray = formattedViewObject(
        'to',
        previewTemplateData?.view_object ?? [],
        tooltipArray?.to,

        watch('mode_of_communication')
      )

      if (
        previewTemplateData?.correspondence_type ===
          COMM_TEMPLATE?.EMAIL_UPPERCASE ||
        previewTemplateData?.category_communication_type_id ===
          COMM_TEMPLATE?.EMAIL_UPPERCASE
      ) {
        setAllToEmails(formattedToArray)
        if (formattedToArray.length > 0 && formattedToArray.length < 2) {
          setValue('to', [formattedToArray?.[0]?.value])
        }
        setAllCcEmails(
          formattedViewObject(
            'cc',
            previewTemplateData?.view_object ?? [],
            tooltipArray?.cc
          )
        )
        setAllBccEmails(
          formattedViewObject(
            'bcc',
            previewTemplateData?.view_object ?? [],
            tooltipArray?.bcc
          )
        )

        setValue('subject', previewTemplateData?.subject)
      } else if (
        previewTemplateData?.correspondence_type ===
          COMM_TEMPLATE?.LETTER_UPPERCASE ||
        previewTemplateData?.category_communication_type_id ===
          COMM_TEMPLATE?.LETTER_UPPERCASE
      ) {
        const formattedLetterArray = formattedViewObjectForLetter(
          'to',
          previewTemplateData?.view_object ?? [],
          tooltipArray?.to
        )
        setToLetterAddress(formattedLetterArray)
        if (formattedLetterArray.length === 1) {
          setValue('letter_address', formattedLetterArray?.[0]?.value)
        }
      } else if (
        previewTemplateData?.correspondence_type ===
          COMM_TEMPLATE.FAX_UPPERCASE ||
        previewTemplateData?.correspondence_type ===
          COMM_TEMPLATE?.SMS_UPPERCASE
      ) {
        if (!isPapFax) {
          setToSmsFax(formattedToArray)
        }
      }
    }
    setViewObjects(previewTemplateData?.view_object ?? [])
    if (previewTemplateData?.attachment)
      setAttachments(previewTemplateData?.attachment ?? [])
    const tempAttachmentKey = previewTemplateData?.attachment?.map(
      (item: Attachment) => {
        return {
          id: item?.id,
          attachment_name: item?.attachment_name,
          attachment_document_type: item?.attachment_document_type,
          attachment_type: item?.attachment_type,
          attachment_document_id: item?.attachment_document_id,
          include_editable_text: item?.include_editable_text,
          contains_docusign: item?.contains_docusign,
          path: item?.path,
        }
      }
    )
    if (tempAttachmentKey) {
      setFetchAttachments(tempAttachmentKey)
      setAttachmentsKey(tempAttachmentKey)
    }
    if (!previewTemplateData) {
      setUpdatedData(null)
      setEditState(false)
    }
  }, [previewTemplateData, tooltipArray])

  // useEffect(() => {
  //   setAttachmentData(attachmentBody?.attachment_data ?? '')
  // }, [attachmentBody])

  useEffect(() => {
    if (previewTemplateData?.body_type !== HTML_TYPE.DOCX_UPPPERCASE) {
      setPreviewData(
        updatedData ?? previewDataWithLink ?? previewTemplateData?.body ?? ''
      )
    }
  }, [editState, previewTemplateData])

  useEffect(() => {
    // if (clientPermissions) {
    //   const hasPermission =
    //     isSuperAdmin ||
    //     handlePermissions(
    //       clientPermissions,
    //       NAMESPACES_MANUAL_COMMUNICATION.CORRESPONDENCE,
    //       NAMESPACES_MANUAL_COMMUNICATION.SEND_MANUAL_COMMUNICATION,
    //       NAMESPACES_MANUAL_COMMUNICATION.SEND_MANUAL_COMMUNICATION
    //     )
    //   setHasSendManualPermission(hasPermission)
    //   if (hasPermission) {
    setHasSendManualPermission(true)
    if (props?.productId)
      fetchAllTemplates(currentPageTemplateName, sizeTemplateName, '')
    fetchAllCases()
    // dispatch(resetSelectedManualCommunicationState())
    // setValue('case_id', '')
    // setValue('template_name', '')
    // setValue('program', '')
    // setValue('service', '')
    // setValue('mode_of_communication', '')
    // setPrograms([])
    // setAllServices([])
    // setAllTemplates([])
    // setCaseIds([])
    // setEditState(false)
    // setUpdatedData(null)
    // setPreviewDataWithLink(null)
    //   }
    // }
  }, [selectedTenantId, props?.productId])

  useEffect(() => {
    if (
      previewTemplateData?.correspondence_type === COMM_TEMPLATE.SMS_UPPERCASE
    ) {
      const plainText = extractTextFromHTML(previewData)
      setLetterCount(plainText.length)
    }
  }, [previewData])

  useEffect(() => {
    if (!props?.task?.resource_id) return

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }

    if (hasTaskUpdated.current) {
      hasTaskUpdated.current = false

      timeoutRef.current = setTimeout(() => {
        fetchStatus()
        timeoutRef.current = null
      }, 2000)
    } else {
      fetchStatus()
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
        timeoutRef.current = null
      }
    }
  }, [props?.task?.resource_id])
  useEffect(() => {
    if (watch('template_name')) {
      getSelectedTemplate(parseInt(watch('template_name')))
    }
  }, [watch('template_name')])

  useEffect(() => {
    if (
      props?.task?.identifier?.sub_ui_identifier ===
      WORKFLOW_UI_IDENTIFIER?.PAP_SEND_COMMUNICATION_FAX
    )
      fetchInsuranceOptions()
  }, [props?.task?.identifier?.bv_case_id])

  return (
    <div className="flex flex-col font-primary bg-accent-0">
      {/* <div className="heading flex justify-between items-center h-16 mb-4.5">
        <div className="headingContent flex flex-col gap-[0.438rem]">
          <span className="text-base font-primary font-medium">
            {COMM_TEMPLATE.SEND_MAIL_COMMUNICATION}
          </span>
          {hasSendManualPermission ? (
            <span className="text-xs text-accent-900 font-primary font-light">
              {COMM_TEMPLATE.SEND_MAIL_COMMUNICATION_MESSAGE}
            </span>
          ) : null}
        </div>
        <div className="search inline-flex justify-end gap-2.5">
          <div className="w-[10rem] flex items-center justify-center">
            <ClientDropdown />
          </div>
        </div>
      </div> */}

      {hasSendManualPermission ? (
        <form className="py-4" method="POST" onSubmit={handleSubmit(onSubmit)}>
          <div className="pl-3 pt-3 pr-3 bg-accent-0 shadow-md pb-3">
            <div className="grid grid-cols-3 gap-4">
              <div className="col-span-1">
                <PaginatedControlledDropDown
                  name={`template_name`}
                  label={COMM_TEMPLATE.TEMPLATE_NAME}
                  errors={errors}
                  control={control}
                  onChange={(e) => {
                    if (props?.isAutoTask) return
                    handleTemplateOptionChange(e)
                  }}
                  options={allTemplates ?? []}
                  required={true}
                  dataQaId={'template_name'}
                  placeholder={
                    props?.isAutoTask && props.isDisabled && templateName
                      ? templateName
                      : undefined
                  }
                  page={currentPageTemplateName}
                  limit={sizeTemplateName}
                  fetchOptions={fetchAllTemplates}
                  virtualScroll={virtualScrollForTemplate}
                  tabIndex={props?.tabIndexOffset}
                  disabled={
                    isReadOnlyUser() ||
                    props?.isDisabled ||
                    !isCaseDetailsEditable()
                  }
                />
              </div>
              <div className="col-span-1">
                {props?.isAutoSms ? (
                  <PhoneInput
                    label={COMM_TEMPLATE.RECIPIENT_PHONE_NUMBER}
                    control={control}
                    placeholder="--"
                    errors={errors}
                    name="recipient_phone_number"
                    validation={{ required: true }}
                    disabled={true}
                    tabIndex={props?.tabIndexOffset}
                  />
                ) : (
                  <FormInput
                    label={COMM_TEMPLATE.MODE_OF_COMM}
                    placeholder="--"
                    errors={errors}
                    name="mode_of_communication"
                    register={register}
                    validation={{ required: true }}
                    disabled={true}
                    tabIndex={props?.tabIndexOffset}
                  />
                )}
              </div>
              <div>
                {!props?.isAutoSms && (
                  <FormInput
                    name="fax_status"
                    disabled
                    value={queuedFax?.status ?? '--'}
                    label="Status"
                    tabIndex={props?.tabIndexOffset}
                  />
                )}
              </div>

              <div className="col-span-1 py-4">
                {props?.task?.identifier?.sub_ui_identifier ===
                WORKFLOW_UI_IDENTIFIER?.PAP_SEND_COMMUNICATION_FAX ? (
                  <ControlledDropDown
                    label={COMM_TEMPLATE.INSURANCE_LABEL}
                    name="insurance_type"
                    options={insuranceOptions}
                    required
                    onChange={(e) => {
                      handleInsuranceOptionChange(
                        e as unknown as DropdownType<string, string>
                      )
                    }}
                    errors={errors}
                    placeholder={'Select Insurance'}
                    control={control}
                    disabled={
                      isReadOnlyUser() ||
                      props?.isDisabled ||
                      !isCaseDetailsEditable()
                    }
                    isCrossable={false}
                  />
                ) : null}
              </div>
            </div>
            <div className="flex flex-col">
              {props?.isAutoSms ? (
                <div className="py-4">
                  <MultiLineInput
                    name="text_message"
                    label={'Text Message'}
                    register={register}
                    defaultValue={watch('text_message')}
                    rows={3}
                    className="text-xs"
                    widthClass=""
                    autoSize={true}
                    tabIndex={props?.tabIndexOffset}
                    disabled={true}
                    renderHTML={true}
                  />
                </div>
              ) : (
                <>
                  <span className="font-primary pb-4 pt-4 font-light text-xs block">
                    {
                      NAMESPACES_MANUAL_COMMUNICATION.GENERATE_COMMUNICATION_MESSAGE
                    }
                  </span>
                  <CustomButton
                    key={enableBtn.toString()}
                    dataQaId="generate-send-enable-disable"
                    disabled={
                      isReadOnlyUser() ||
                      !isCaseDetailsEditable() ||
                      !enableBtn ||
                      props?.isDisabled ||
                      !!props?.task?.resource_id
                    }
                    isFilled={true}
                    className={`h-[2.375rem] flex gap-1 items-center ${getGenerateSendButtonClass(
                      props?.isDisabled ? !props?.isDisabled : enableBtn
                    )}`}
                    type="button"
                    tabIndex={props?.tabIndexOffset}
                    onClick={() => onSubmit()}
                  >
                    {getGenerateSendButtonIcon(enableBtn)}
                    <span
                      className={`font-primary ${getGenerateTextClassName(
                        enableBtn
                      )}
                `}
                    >
                      {COMM_TEMPLATE.GENERATE}
                    </span>
                  </CustomButton>
                </>
              )}
            </div>
          </div>
          {previewTemplateData && (
            <div className="bg-accent-0 shadow-md pl-3 pr-3 pb-3 ">
              <div className="flex gap-4 justify-end mb-3">
                {watch('mode_of_communication') === COMM_TEMPLATE.EMAIL &&
                  previewTemplateData.contains_docusign && (
                    <CustomButton
                      dataQaId="send-via-docusign"
                      type="button"
                      color="primary"
                      widthClass="w-[9.313rem]"
                      className="text-xs"
                      isFilled={true}
                      disabled={
                        isReadOnlyUser() || checkIfEnabled(previewDataWithLink)
                      }
                      onClick={sendCommunicationTemplateViaDocuSign}
                      tabIndex={props?.tabIndexOffset}
                    >
                      {BUTTONS.SEND_VIA_DOCUSIGN}
                    </CustomButton>
                  )}
                {
                  (watch('mode_of_communication') === COMM_TEMPLATE.EMAIL ||
                    watch('mode_of_communication') === COMM_TEMPLATE.FAX ||
                    watch('mode_of_communication') === COMM_TEMPLATE.LETTER ||
                    watch('mode_of_communication') === COMM_TEMPLATE.SMS) && (
                    //   !(
                    //   isReadOnlyUser() ||
                    //   !!props?.task?.resource_id ||
                    //   (props?.isDisabled ?? handleDisable())
                    // ) ?
                    //  (
                    <CustomButton
                      key={
                        (watch('to') ?? [])?.toString() +
                        (watch('letter_address') ?? [])?.toString()
                      }
                      dataQaId="send-communication-template"
                      type="button"
                      color="primary"
                      widthClass="w-[5.563rem]"
                      className="text-xs"
                      isFilled={true}
                      onClick={sendCommunicationTemplate}
                      tabIndex={props?.tabIndexOffset}
                      disabled={
                        isReadOnlyUser() ||
                        !!props?.task?.resource_id ||
                        (props?.isDisabled ?? handleDisable())
                      }
                    >
                      <span className="text-xs font-light">
                        {getButtonText()}
                      </span>
                    </CustomButton>
                  )
                  //  : (
                  //   <CustomButton
                  //     type="button"
                  //     color="primary"
                  //     widthClass="w-[5.563rem]"
                  //     className="text-xs"
                  //     isFilled={true}
                  //     onClick={resendCorresponsence}
                  //   >
                  //     {BUTTONS?.RESEND}
                  //   </CustomButton>
                  // )
                  // )
                }
              </div>
              {(watch('mode_of_communication') === COMM_TEMPLATE.EMAIL ||
                watch('mode_of_communication') === COMM_TEMPLATE.FAX ||
                watch('mode_of_communication') === COMM_TEMPLATE.LETTER ||
                watch('mode_of_communication') === COMM_TEMPLATE.SMS) && (
                <div className="px-5 header cursor-pointer h-10 items-center rounded relative z-index-1 border bg-accent-0 flex border-l-4 border-l-primary-500 ">
                  <div className="w-[98%] text-base font-medium  mr-3">
                    <div className="font-medium text-base">
                      {watch('mode_of_communication') === COMM_TEMPLATE.EMAIL &&
                        COMM_TEMPLATE.EMAIL}
                      {watch('mode_of_communication') === COMM_TEMPLATE.FAX &&
                        COMM_TEMPLATE.FAX}
                      {watch('mode_of_communication') ===
                        COMM_TEMPLATE.LETTER && COMM_TEMPLATE.LETTER}
                      {watch('mode_of_communication') === COMM_TEMPLATE.SMS &&
                        COMM_TEMPLATE.SMS}
                    </div>
                  </div>
                </div>
              )}
              {/* Auto Populated Fields */}
              {watch('mode_of_communication') === COMM_TEMPLATE.EMAIL && (
                <div className="pt-6 pl-3 pr-3 pb-3 gap-4 border -mt-1 border-t-0 border-l-1 border-border-100 rounded-[0.25rem]">
                  <div className="grid grid-cols-2 mb-4 gap-4">
                    <div className="col-span-1">
                      <ControlledMultiSelect
                        key={watch('to')?.toString()}
                        options={allToEmails}
                        name="to"
                        label={COMM_TEMPLATE.TO}
                        noOfChips={1}
                        isSearchable={false}
                        errors={errors}
                        control={control}
                        required={true}
                        onChange={(e: DropdownType<string>[]) => {
                          const valuesArray = e.map((item) => item.value)
                          setValue('to', valuesArray)
                        }}
                        dataQaId={'to'}
                        tabIndex={props?.tabIndexOffset}
                        modifiedTooltip={tooltipArray?.to}
                        disabled={isReadOnlyUser() || props?.isDisabled}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 mb-4 gap-4">
                    <div className="col-span-1">
                      <ControlledMultiSelect
                        options={allCcEmails}
                        name="cc"
                        label={COMM_TEMPLATE.CC}
                        noOfChips={1}
                        isSearchable={false}
                        errors={errors}
                        control={control}
                        required={false}
                        onChange={(e: DropdownType<string>[]) => {
                          const valuesArray = e.map((item) => item.value)
                          setValue('cc', valuesArray)
                        }}
                        dataQaId={'cc'}
                        tabIndex={props?.tabIndexOffset}
                        modifiedTooltip={tooltipArray?.cc}
                        disabled={isReadOnlyUser() || props?.isDisabled}
                      />
                    </div>
                    <div className="col-span-1">
                      <ControlledMultiSelect
                        options={allBccEmails}
                        name="bcc"
                        label={COMM_TEMPLATE.BCC}
                        noOfChips={1}
                        isSearchable={false}
                        errors={errors}
                        control={control}
                        required={false}
                        onChange={(e: DropdownType<string>[]) => {
                          const valuesArray = e.map((item) => item.value)
                          setValue('bcc', valuesArray)
                        }}
                        dataQaId={'bcc'}
                        tabIndex={props?.tabIndexOffset}
                        modifiedTooltip={tooltipArray?.bcc}
                        disabled={isReadOnlyUser() || props?.isDisabled}
                      />
                    </div>
                  </div>
                  <div className="col-span-1">
                    <FormInput
                      label={COMM_TEMPLATE.SUBJECT}
                      placeholder="--"
                      errors={errors}
                      name="subject"
                      register={register}
                      validation={{ required: true }}
                      disabled={true}
                      dataQaId={'subject'}
                      tabIndex={props?.tabIndexOffset}
                    />
                  </div>
                </div>
              )}
              {watch('mode_of_communication') === COMM_TEMPLATE.SMS && (
                <div className="pt-6 pl-3 pr-3 pb-3 gap-4 border -mt-1 border-t-0 border-l-1 border-border-100 rounded-[0.25rem]">
                  <div className="grid grid-cols-1 mb-4">
                    <div className="col-span-1">
                      <ControlledMultiSelect
                        key={watch('to')?.toString()}
                        options={toSmsFax}
                        name="to"
                        label={COMM_TEMPLATE.SMS_RECIPIENTS}
                        noOfChips={3}
                        isSearchable={false}
                        errors={errors}
                        control={control}
                        required={true}
                        onChange={(e: DropdownType<string>[]) => {
                          const valuesArray = e.map((item) => item.value)
                          setValue('to', valuesArray)
                        }}
                        dataQaId={'to'}
                        tabIndex={props?.tabIndexOffset}
                        modifiedTooltip={tooltipArray?.to}
                        disabled={isReadOnlyUser() || props?.isDisabled}
                      />
                    </div>
                  </div>
                </div>
              )}
              {watch('mode_of_communication') === COMM_TEMPLATE.FAX && (
                <div className="pt-6 pl-3 pr-3 pb-3 gap-4 border -mt-1 border-t-0 border-l-1 border-border-100 rounded-[0.25rem]">
                  <div className="grid grid-cols-1 mb-4">
                    <div className="col-span-1">
                      <ControlledDropDown
                        key={watch('to')?.toString()}
                        options={toSmsFax}
                        name="to"
                        label={COMM_TEMPLATE.RECIPIENTS_FAX_NUMBER}
                        isSearchable={false}
                        errors={errors}
                        control={control}
                        required={true}
                        onChange={(value: DropdownType<string>) => {
                          setValue('to', value?.value, {
                            shouldValidate: true,
                          })
                          setViewObjects([
                            value?.viewObject as unknown as ViewObjectEntry,
                          ])
                        }}
                        dataQaId={'to'}
                        tabIndex={props?.tabIndexOffset}
                        disabled={isReadOnlyUser() || props?.isDisabled}
                        placeholder={
                          props?.task?.resource_id
                            ? selectedRecipientLabel
                            : undefined
                        }
                      />
                    </div>
                  </div>
                </div>
              )}
              {watch('mode_of_communication') === COMM_TEMPLATE.LETTER && (
                <div className="pt-6 pl-3 pr-3 pb-3 gap-4 border -mt-1 border-t-0 border-l-1 border-border-100 rounded-[0.25rem]">
                  <div className="grid grid-cols-2 mb-4">
                    <div className="col-span-1">
                      <ControlledDropDown
                        key={watch('letter_address')?.toString()}
                        options={toLetterAddress}
                        name="letter_address"
                        label={COMM_TEMPLATE.RECIPIENT_NAME}
                        isSearchable={false}
                        errors={errors}
                        control={control}
                        required={true}
                        onChange={(value: DropdownType<string>) => {
                          setValue('letter_address', value?.value, {
                            shouldValidate: true,
                          })
                          setViewObjects([
                            value?.viewObject as unknown as ViewObjectEntry,
                          ])
                        }}
                        dataQaId={'letter_address'}
                        tabIndex={props?.tabIndexOffset}
                        disabled={isReadOnlyUser() || props?.isDisabled}
                        placeholder={
                          props?.task?.resource_id
                            ? selectedRecipientLabel
                            : undefined
                        }
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* Attachments */}
              {watch('mode_of_communication') !== COMM_TEMPLATE.SMS &&
                watch('mode_of_communication') === COMM_TEMPLATE.EMAIL && (
                  <div className="attachments custom-shadow p-3 mt-3 rounded-[0.25rem]">
                    <div className="flex items-center justify-between">
                      <span className="text-base font-light flex">
                        {COMM_TEMPLATE.ATTACHMENTS}
                      </span>
                      {props?.task?.resource_id ? null : (
                        <MiscUploadButton
                          setAttachmentsKey={setAttachmentsKey}
                          setAttachments={setAttachments}
                        />
                      )}
                    </div>
                    <div className="w-full overflow-x-auto h-[5.7rem]">
                      {attachments?.length === 0 ? (
                        <span className="h-full flex items-center justify-center font-bold">
                          {COMM_TEMPLATE.NO_ATTACHED_DOCUMENTS}
                        </span>
                      ) : (
                        <ul className="attachments-list flex gap-4 mt-3">
                          {attachments?.map(
                            (item: Attachment) =>
                              item?.attachment_document_type !==
                                COMM_TEMPLATE.COVER_SHEET_KEY && (
                                <li
                                  key={item.id}
                                  className="data flex items-center border rounded-[0.25rem] p-2 border-border-200 h-10 w-[16rem]"
                                >
                                  <div className="flex justify-between items-center w-full">
                                    <Tooltip
                                      content={item?.attachment_name}
                                      position="bottom"
                                    >
                                      <div
                                        className="flex items-center gap-2 justify-center"
                                        onClick={() =>
                                          handleAttachmentEditClick(
                                            item,
                                            MODAL_TYPES.LINK
                                          )
                                        }
                                      >
                                        <div>
                                          {getFileIcon(
                                            item?.attachment_name ??
                                              item?.attachment_type
                                          )}
                                        </div>
                                        <span className="font-primary text-xs truncate">
                                          <div className="ml-1 font-primary text-xs font-light text-ellipsis overflow-hidden cursor-pointer truncate w-[8rem]">
                                            {item.attachment_name}
                                          </div>
                                        </span>
                                      </div>
                                    </Tooltip>
                                    <div className="flex items-center">
                                      {item?.contains_docusign && (
                                        <div className="p-0.5 ml-auto docusign">
                                          <div className="border-secondary-500">
                                            <SvgDocuSign className="hover:border-secondary-500" />
                                          </div>
                                        </div>
                                      )}
                                      {item?.contains_docusign &&
                                        item?.include_editable_text && (
                                          <div className="text-accent-200">
                                            |&nbsp;&nbsp;
                                          </div>
                                        )}
                                      {item?.include_editable_text && (
                                        <div
                                          onClick={() => {
                                            handleAttachmentEditClick(
                                              item,
                                              MODAL_TYPES.EDIT
                                            )
                                          }}
                                          className="hover:bg-secondary-25 p-0.5 ml-auto edit"
                                        >
                                          <div className="border-secondary-500">
                                            <SvgEdit className="hover:border-secondary-500" />{' '}
                                          </div>
                                        </div>
                                      )}
                                      {item?.contains_docusign &&
                                        item?.include_editable_text && (
                                          <div className="text-accent-200">
                                            |&nbsp;&nbsp;
                                          </div>
                                        )}
                                      <button
                                        onClick={() =>
                                          handleAttachmentDeleteClick(item)
                                        }
                                        type="button"
                                        className="hover:bg-secondary-25 p-0.5 ml-auto edit"
                                        tabIndex={props?.tabIndexOffset}
                                      >
                                        <div className="border-secondary-500">
                                          <SvgCross className="hover:border-secondary-500" />{' '}
                                        </div>
                                      </button>
                                    </div>
                                  </div>
                                </li>
                              )
                          )}
                        </ul>
                      )}
                    </div>
                  </div>
                )}
              {(watch('mode_of_communication') === COMM_TEMPLATE.FAX ||
                watch('mode_of_communication') === COMM_TEMPLATE.LETTER) && (
                <DraggableAttachableList
                  setAttachmentsKey={setAttachmentsKey}
                  setAttachments={setAttachments}
                  attachments={attachments}
                  handleViewClick={handleViewClick}
                  handleAttachmentEditClick={handleAttachmentEditClick}
                  handleAttachmentDeleteClick={handleAttachmentDeleteClick}
                  tabIndexOffset={props?.tabIndexOffset}
                  isViewMode={!!props?.task?.resource_id}
                  hideUploadButton={!!props.task?.resource_id}
                />
              )}
              {watch('mode_of_communication')?.toUpperCase() !==
                COMM_TEMPLATE.SMS && (
                <div
                  className={`template-data ${getClassOnEditState(
                    editState
                  )} mt-4 p-3 border-t-[2px] border-t-accent-900`}
                >
                  <div className="flex justify-between">
                    <span className="text-base">
                      {!editState && COMM_TEMPLATE.COVERSHEET_PREVIEW}
                      {editState && COMM_TEMPLATE.REVIEW_EDITABLE_TEXT}
                    </span>
                    {previewTemplateData?.include_editable_text &&
                      !editState && (
                        <button
                          onClick={() => {
                            setEditState(true)
                          }}
                        >
                          {<SvgEdit />}
                        </button>
                      )}
                    {editState && (
                      <div className="flex gap-4">
                        <CustomButton
                          dataQaId="cancel-edit-body-preview"
                          type="button"
                          color="primary"
                          widthClass="w-[5.563rem]"
                          className="text-xs"
                          isFilled={false}
                          onClick={() => {
                            setEditState(false)
                            setPreviewData(
                              previewDataWithLink ?? previewTemplateData.body
                            )
                          }}
                          disabled={isReadOnlyUser()}
                        >
                          <span className="text-xs font-light">
                            {NAMESPACES_MANUAL_COMMUNICATION.CANCEL}
                          </span>
                        </CustomButton>
                        <CustomButton
                          dataQaId="save-edit-updated-html"
                          type="button"
                          color="primary"
                          widthClass="w-[5.563rem]"
                          className="text-xs"
                          isFilled={true}
                          onClick={handleSave}
                          disabled={isReadOnlyUser()}
                        >
                          <span className="text-xs font-light">
                            {NAMESPACES_MANUAL_COMMUNICATION.SAVE}
                          </span>
                        </CustomButton>
                      </div>
                    )}
                  </div>
                  <GenericRenderPreview
                    data={previewData}
                    editableRef={editableRef}
                    editState={editState}
                    getFormattedHtml={getFormatedHtmlData}
                    variant="default"
                    fetchPreviewUrl={fetchUrlWithLoader}
                  />
                </div>
              )}
              {watch('mode_of_communication') === COMM_TEMPLATE.SMS && (
                <div className="w-full font-primary mt-2.5">
                  <div
                    className={`relative group p-3 border border-border-100 mt-3 rounded-lg ${
                      !editState && 'bg-tertiary-100'
                    }`}
                  >
                    <label
                      className={`flex gap-2 absolute left-4 -top-3 px-2 text-xs font-medium bg-accent-0 transition-all pointer-events-none ${
                        editState ? 'text-secondary-500' : 'text-accent-500'
                      } group-focus-within:text-secondary-500`}
                      style={{
                        zIndex: 10,
                      }}
                    >
                      <span>{COMM_TEMPLATE.SMS_MESSAGE}</span>
                      <span className="flex text-xs text-accent-400">
                        ({letterCount}/{FIELD_VALUE_CONSTANTS.ONE_HUNDRED_SIXTY}
                        )
                      </span>
                    </label>
                    <div className="flex justify-between">
                      <strong className="text-base text-accent-900"></strong>
                      {previewTemplateData?.include_editable_text &&
                        !editState && (
                          <button
                            onClick={() => {
                              setEditState(true)
                            }}
                          >
                            {<SvgEdit />}
                          </button>
                        )}
                      {editState && (
                        <div className="flex gap-4">
                          <CustomButton
                            dataQaId="cancel-message-preview-data-with-link"
                            type="button"
                            color="primary"
                            widthClass="w-[5.563rem]"
                            className="text-xs"
                            isFilled={false}
                            onClick={() => {
                              setEditState(false)
                              setPreviewData(
                                previewDataWithLink ?? previewTemplateData.body
                              )
                            }}
                          >
                            <span className="text-xs font-light">
                              {NAMESPACES_MANUAL_COMMUNICATION.CANCEL}
                            </span>
                          </CustomButton>
                          <CustomButton
                            dataQaId="save-message-final-html"
                            type="button"
                            color="primary"
                            widthClass="w-[5.563rem]"
                            className="text-xs"
                            isFilled={true}
                            onClick={handleSave}
                          >
                            <span className="text-xs font-light">
                              {NAMESPACES_MANUAL_COMMUNICATION.SAVE}
                            </span>
                          </CustomButton>
                        </div>
                      )}
                    </div>
                    <div
                      ref={editableRef}
                      dangerouslySetInnerHTML={{
                        __html: editState
                          ? makeEditableWithRedBackground(previewData)
                          : removeEditableAndRedBackground(previewData),
                      }}
                      className="bg-inherit ck-content overflow-x-auto outline-none px-2 h-[8.625rem] rounded-lg min-h-10"
                    />
                  </div>
                </div>
              )}
            </div>
          )}
        </form>
      ) : (
        <NegativeScreen message={'no module present'} />
      )}
      {modal.state && (
        <div className="a4modal">
          <Modal
            isOpen={modal.state}
            closeModal={() => setModal({ type: '', state: false })}
            showCloseButton={false}
            closeModalOnOutsideClick={false}
            className="border rounded-none"
            isDragable
            isBackdropInteractive
          >
            <div className="flex flex-col w-[49.5rem]">
              <div className="flex justify-between items-center">
                <div className="font-medium text-sm">
                  {modal.type === MODAL_TYPES.EDIT ? (
                    <span>{COMM_TEMPLATE?.EDIT_DOCUMENT} - </span>
                  ) : (
                    <span>{COMM_TEMPLATE?.VIEW_DOCUMENT} - </span>
                  )}

                  <span>{attachmentBody?.attachment_name}</span>
                </div>
                <div className="flex items-center gap-3">
                  <DocumentPopout
                    source={attachmentData}
                    generateUrl={() =>
                      fetchFilePreviewUrl(previewAttachmentPath.current)
                    }
                  />
                  <button
                    className="cursor-pointer"
                    onClick={() =>
                      getDownloadURL(
                        dispatch,
                        caseKey ?? watch('case_id'),
                        attachmentData,
                        attachmentBody?.attachment_name,
                        documentType
                      )
                    }
                    data-qa-id="download-file"
                  >
                    <SvgDownloadGrey />
                  </button>

                  <div
                    className="flex items-center justify-center h-4 w-4 cursor-pointer"
                    onClick={() => setModal({ type: '', state: false })}
                  >
                    <SvgCross height={'0.875rem'} width={'0.875rem'} />
                  </div>
                </div>
              </div>
              <div className="flex flex-col justify-between mt-4">
                {modal.type === MODAL_TYPES.EDIT && (
                  <div
                    className={`border border-border-200 ck-content flex mb-4 w-full overflow-x-auto px-3 py-4  ${
                      modal.type === MODAL_TYPES.EDIT
                        ? 'doc-wrap-height-edit'
                        : 'doc-wrap-height'
                    }`}
                  >
                    <div
                      ref={editableAttachmentRef}
                      dangerouslySetInnerHTML={{
                        __html: makeEditableWithRedBackground(
                          formatHtmlBeforePreview(attachmentData)
                        ),
                      }}
                      className="document-editor__editable-container bg-accent-0 h-fit w-full overflow-hidden"
                    />
                  </div>
                )}
                {modal.type !== MODAL_TYPES.EDIT && (
                  <div
                    className={`border border-accent-200 w-full document-editor__editable-container-view mt-2 bg-white overflow-clip`}
                  >
                    <PdfViewer
                      pdfUrl={attachmentData}
                      isBase64={
                        previewTemplateData?.body_type !==
                        HTML_TYPE.DOCX_UPPPERCASE
                      }
                      allowZoom={false}
                      showPageNumber={false}
                      defaultZoomScale={1.3}
                    />
                  </div>
                )}
                {modal.type === MODAL_TYPES.EDIT && (
                  <div className="flex gap-4 items-center justify-end w-full mt-6">
                    <CustomButton
                      dataQaId="cancel-message-edit-modal-send-communication"
                      onClick={() => {
                        setModal({ type: '', state: false })
                      }}
                      color="primary"
                      className="border border-primary-500 text-xs"
                      disabled={isReadOnlyUser()}
                    >
                      <span className="text-xs font-light">
                        {BUTTONS.CANCEL}
                      </span>
                    </CustomButton>
                    <CustomButton
                      dataQaId="save-message-attachment-communication"
                      onClick={handleSaveAttachments}
                      color="primary"
                      isFilled={true}
                      disabled={isReadOnlyUser()}
                    >
                      <span className="text-xs font-light">{BUTTONS.SAVE}</span>
                    </CustomButton>
                  </div>
                )}
              </div>
            </div>
          </Modal>
        </div>
      )}

      {isOpenModal && (
        <div className="a4modal">
          <Modal
            isOpen={true}
            closeModal={() => {
              setIsOpenModal(false)
            }}
            showCloseButton={false}
            isDragable
            isBackdropInteractive
          >
            <div className="flex flex-col">
              <div className="flex justify-between items-center">
                <div className="font-bold text-sm">
                  <span>{COMM_TEMPLATE?.VIEW_DOCUMENT} - </span>
                  <span>{staticFileName}</span>
                </div>

                <div className="flex items-center gap-3">
                  <DocumentPopout
                    source={previewUrl}
                    generateUrl={() =>
                      fetchFilePreviewUrl(previewAttachmentPath.current)
                    }
                  />
                  <button
                    className="cursor-pointer"
                    onClick={() =>
                      getDownloadURL(
                        dispatch,
                        watch('case_id'),
                        previewUrl,
                        staticFileName,
                        documentType
                      )
                    }
                    data-qa-id="download-file"
                  >
                    <SvgDownloadGrey />
                  </button>
                  <div
                    className="flex items-center justify-center h-4 w-4 cursor-pointer"
                    onClick={() => setIsOpenModal(false)}
                  >
                    <SvgCross height={'0.875rem'} width={'0.875rem'} />
                  </div>
                </div>
              </div>
              <div className="px-3 py-4 border border-border-100 ck-content doc-wrap-height mt-4">
                <iframe
                  title="file preview"
                  src={`${previewUrl}#toolbar=0&navpanes=0&zoom=66`}
                  style={{ border: 0 }}
                  height="500"
                  className="w-full max-w-full min-w-[800px]"
                />
              </div>
            </div>
          </Modal>
        </div>
      )}
    </div>
  )
}

const NegativeScreen = ({ message }: { message: string }) => {
  return (
    <div className="h-[25.75rem] mt-[2.125rem] mx-0 border border-accent-100 rounded-lg">
      <div className="flex flex-col justify-center items-center gap-[1.5rem] h-full">
        <div>
          <SvgWarningNew />
        </div>
        <div className="font-light text-xs">{message}</div>
      </div>
    </div>
  )
}

export default SendManualCommunication
